import { Inject, Injectable, InjectionToken } from '@angular/core';
import { PaginatedState, PaginatedStateLoadingMode, PaginatedStateModel } from '@shared/ui';

export const DEVICE_PAGINATION_MODE = new InjectionToken<PaginatedStateLoadingMode>('DEVICE_PAGINATION_MODE');

export interface DeviceData {
  id: string;
  name: string;
  organizationName?: string;
  organizationLogoUrl?: string;
  deviceTypeId?: string;
  deviceTypeName: string;
  deviceTypeVersion: string;
  serialNumber?: string;
  createdAt: Date;
}

export interface DeviceStoreState extends PaginatedStateModel<DeviceData> {
  organizationId?: string;
}

@Injectable()
export class DeviceState extends PaginatedState<DeviceData, DeviceStoreState> {
  constructor(@Inject(DEVICE_PAGINATION_MODE) loadingMode: PaginatedStateLoadingMode) {
    super({ loadingMode }, { organizationId: undefined });
  }

  // ============================================================================
  // Custom Selectors
  // ============================================================================

  public readonly organizationId$ = this.select((state) => state.organizationId);

  public readonly devices$ = this.items$;
  public readonly totalDeviceCount$ = this.totalCount$;
  public readonly nextDeviceToken$ = this.nextToken$;
  public readonly previousDeviceTokens$ = this.previousTokens$;
  public readonly devicesLoaded$ = this.itemsLoaded$;
  public readonly noDevices$ = this.noItems$;

  // ============================================================================
  // Custom Updaters
  // ============================================================================

  public readonly setOrganizationId = this.updater(
    (state, organizationId: string | undefined) => ({ ...state, organizationId } as DeviceStoreState)
  );
}
